import { type HomeHealthAlertRow } from "./types";

// Labels, alert keys, and tooltip copy mirror the Figma exactly — do not paraphrase.
export const HOME_HEALTH_ALERT_ROWS: readonly HomeHealthAlertRow[] = [
  {
    id: "chatMessages",
    label: "Chat messages",
    tooltip: "Notifications when a clinician messages you through Clipboard",
    smsAlertKey: "chatMessages",
  },
  {
    id: "visitPended",
    label: "Visit Pended",
    emailAlertKey: "visitPendedEmail",
    tooltip: "Notifications when a clinician marks a booked visit as pending",
  },
  {
    id: "visitConfirmed",
    label: "Visit Confirmed",
    emailAlertKey: "visitConfirmedEmail",
    tooltip: "Notifications when a clinician shares their first visit date",
  },
  {
    id: "visitLogged",
    label: "Visit logged",
    emailAlertKey: "visitLoggedEmail",
    tooltip: "Notifications when a clinician logs a visit",
  },
  {
    id: "visitUnassigned",
    label: "Worker unassigned from visit",
    emailAlertKey: "visitUnassignedWorkplaceEmail",
    tooltip: "Notifications when a clinician cancels or is removed from a visit",
  },
  {
    id: "visitVerificationReminder",
    label: "Visit verification reminder",
    emailAlertKey: "visitVerificationReminderEmail",
    tooltip: "Reminder to verify outstanding visits",
  },
] as const;

export const ALL_NOTIFICATIONS_LABEL = "All notifications";

// Master toggle's alertKey within a channel (EMAIL or SMS). Writing
// { enabled: false } here maps to Knock's channel-level mute
// (NotificationPreferences.channelTypes.email / .sms), suppressing every
// workflow on that channel for the user across every workplace.
export const MASTER_ALERT_KEY = "All";
